export const isQuarterOptionDisabled = (reports, inputtedYear, quarter) => {
  for (let i = 0; i < reports.length; i++) {
    if (parseInt(reports[i].year) === parseInt(inputtedYear) && parseInt(reports[i].quarter) === parseInt(quarter)) {
      return true;
    }
  }

  return false;
};
